<template>
  <div class="manual">
    <!--目次の取得前に子を描画すると、目次を参照している画面が落ちる-->
    <router-view v-if="manualSectionListLoaded === true" />
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    toolCodeKebab: String,
  },
  data() {
    return {
      manualSectionListLoaded: false,
    };
  },
  computed: {
    rt() {
      return this.$store.getters.rt;
    },
    tools() {
      return this.$store.getters.tools;
    },
    toolId() {
      return this.$store.getters.toolIdFromToolCode(this.toolCodeKebab);
    },
  },
  watch: {
    //ツール一覧の読み込みが終わるまで toolId は undefined なので、確定してから取得する。
    //ツールを切り替えたときも取り直す
    toolId: {
      immediate: true,
      handler() {
        this.setManualSectionList();
      },
    },
  },
  created() {
    const hash = "#" + this.$route.query.hash;
    this.$nextTick(() => {
      this.$scrollTo(hash, 0, {});
    });
  },
  methods: {
    setManualSectionList() {
      //目次はマニュアル画面でしか使わないので、ここで取得する
      this.manualSectionListLoaded = false;
      if (this.toolId !== undefined) {
        // ok.
      } else {
        //ツール一覧がまだ読み込まれていない。 確定したら watcher が呼び直す
        return;
      }

      this.$store
        .dispatch("setManualSectionList", this.toolId)
        .then(() => {
          this.manualSectionListLoaded = true;
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
:deep(h3) {
  margin-top: 50px;
  &:before {
    content: "▶";
  }
}
:deep(.v-scroll-to) {
  color: #00e;
  cursor: pointer;
}
:deep(.typeB) {
  margin: 20px 0;
}
:deep(.el-textarea) {
  margin: 20px 0;
}
img.border {
  width: 100%;
  box-sizing: border-box;
  border: solid 3px #ddd;
}
</style>
